import type { InvitePreviewResponse } from '@lunya/contracts'

import type { InvitePreview } from '../../types'

/**
 * Превью приглашения (экран B0) → клиентский тип.
 *
 * Пол пригласившего переносим как есть, включая `null`: из него собирается фраза о позвавшем
 * («{он|она} увидит» на B·3), и любая подстановка по умолчанию тут же даёт обращение не в том
 * роде. `null` — это не «неизвестно, возьмём женский», а «говорим без рода».
 */
export function mapInvitePreviewFromApi(dto: InvitePreviewResponse): InvitePreview {
  return {
    inviterName: dto.inviter_first_name,
    inviterGender: dto.inviter_gender,
  }
}
